export default "__VITE_ASSET__1DeohKNr__"